// extracted by mini-css-extract-plugin
export default {"container":"MJ-z","dimension":"NJ-z","dimensionLabels":"OJ-z"};